import * as React from "react";
import { forwardRef, memo } from "react";
const SvgTrendingDown = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M20 16.9646L12.6154 9.4646L9.53846 12.5896L4 6.9646M20 16.9646V11.9646M20 16.9646H15.0769", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgTrendingDown);
const Memo = memo(ForwardRef);
export default Memo;
